namespace RioERP.Orders {
    export interface OrdershippingPendrivesForm {
        OrderId: Serenity.LookupEditor;
        ProductId: Serenity.LookupEditor;
        PenDriveTypeId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
    }

    export class OrdershippingPendrivesForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.OrdershippingPendrives';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OrdershippingPendrivesForm.init)  {
                OrdershippingPendrivesForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(OrdershippingPendrivesForm, [
                    'OrderId', w0,
                    'ProductId', w0,
                    'PenDriveTypeId', w0,
                    'Quantity', w1
                ]);
            }
        }
    }
}
